<template>
  <div class="header">
    <div class="title">
      <div class="left">
        <!-- <hamburger @toggleClick="toggleSideBar" /> -->
        <!-- 控制菜单的收缩 -->
        <div @click="shrinkMenu" class="shrink">
          <i
            style="font-size: 25px"
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          ></i>
        </div>

        <!-- && (info.campus || info.job) -->
        <!-- <a v-if="info.utype">{{
          info.utype == "1"
            ? "超级管理员"
            : info.utype == "6"
            ? "校区校长"
            : info.utype == "12"
            ? "财务"
            : "顾问"
        }}</a> -->
        <a>首页&nbsp;&nbsp;/&nbsp;&nbsp;{{ routerTitle }}</a>
        <!-- <a v-if="role_id !== '1'">-</a> -->
        <a>{{ info.job }}</a>
      </div>
      <div class="right">
        <div class="user">
          <img src="../../assets/avatar.png" alt="" />
          <span>{{ info.userName }}</span>

          <el-button type="primary" size="small" @click.native="logout"
            >退出</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hamburger from "@/components/Hamburger";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      name: localStorage.getItem("account"),
      info: {},
      role_id: "",
      isCollapse: false,
      routerTitle: "",
    };
  },
  components: {
    Hamburger,
  },
  computed: {},
  watch: {
    $route(newRoute) {
      this.routerTitle = newRoute.meta.title; // 将新的路由信息保存到组件的monitoredRoute属性中
      // 执行其他操作或调用其他方法
    },
  },

  created() {
    this.routerTitle = this.$route.meta.title;
    // setTimeout(() => {
    this.info = JSON.parse(localStorage.getItem("userInfo"));
    this.role_id = this.info.id;
  },
  methods: {
    shrinkMenu() {
      this.isCollapse = !this.isCollapse;
      this.$store.dispatch("app/changeCollapse", true);
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      // await this.$store.dispatch("user/logout");
      localStorage.clear();
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  position: relative;
  height: 76px;
  z-index: 1030;
  background-color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  .title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .shrink {
        cursor: pointer;
      }
      a {
        color: #606266;
        font-size: 23px;
        margin-left: 20px;
      }
    }
    .right {
      // margin-right: 60px;
      .user {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 15px;
        }
        span {
          font-size: 20px;
          color: #606266;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
